/**
 * @file Is the default authentication module used by the API and should be replaced by a suited
 * module in each project, since every project has specific requirements.
 *
 * If you desire to use another authentication module, see {@link defaultsProvider.js} docs.
 *
 * This module possess the default token name, specified with the constant @const tokenName
 *
 * @module authentication
 *
 * @author Hugo Azevedo
 */

import Cookies from './store';

export default function authentication({store = Cookies, tokenName = 'stilingue-session-id'} = {}) {
  return {
    /**
    * @function getSessionId
    * @param {Object} options
    * @returns {string | null}
    */
    getSessionId(options = {}) {
      return store.get(tokenName, options);
    },
    /**
    * @function setSessionId
    * @param {string} token
    * @param {Object} options
    * @returns {undefined}
    */
    setSessionId(token, options = {}) {
      return store.set(tokenName, token, options);
    },
    /**
    * @function removeSessionId
    * @param {Object} options
    * @returns {undefined}
    */
    removeSessionId(options = {}) {
      return store.remove(tokenName, options);
    },
    /**
    * @function getTokenName
    * @returns {string}
    */
    getTokenName() {
      return tokenName;
    },
  };
}

